import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PropTypes from 'prop-types';
import { useDialogsContext } from './DialogsContext.js';

const DialogsRenderer = () => {
  const {
    dialogs,
    dispatch
  } = useDialogsContext();
  return dialogs.map(({
    id,
    Component,
    isOpen,
    props = {}
  }) => /*#__PURE__*/React__default.createElement(Component, _extends({
    key: id
  }, props, {
    isOpen: isOpen,
    onClose: async e => {
      await props.onClose?.(e);
      dispatch({
        type: 'close',
        payload: id
      });
      setTimeout(() => {
        dispatch({
          type: 'cleanup',
          payload: id
        });
      }, 500);
    },
    onClosed: async node => {
      await props.onClosed?.(node);
      dispatch({
        type: 'remove',
        payload: id
      });
    },
    close: () => {
      dispatch({
        type: 'close',
        payload: id
      });
    }
  })));
};
DialogsRenderer.displayName = 'NuiDialogsRenderer';
const DialogsRendererPropTypes = {
  close: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onClosed: PropTypes.func.isRequired
};
var DialogsRenderer$1 = DialogsRenderer;

export { DialogsRendererPropTypes, DialogsRenderer$1 as default };
